var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3262 38.1383C16.865 38.1383 13.4816 37.112 10.6037 35.189C7.72584 33.2661 5.48282 30.533 4.15829 27.3353C2.83375 24.1376 2.4872 20.6189 3.16244 17.2242C3.83768 13.8296 5.50439 10.7114 7.95181 8.26394C10.3992 5.81653 13.5174 4.14981 16.9121 3.47457C20.3068 2.79933 23.8254 3.14589 27.0231 4.47042C30.2208 5.79496 32.954 8.03797 34.8769 10.9158C36.7998 13.7937 37.8262 17.1771 37.8262 20.6383C37.8262 25.2796 35.9824 29.7308 32.7005 33.0127C29.4187 36.2946 24.9675 38.1383 20.3262 38.1383ZM20.3262 5.63831C17.3595 5.63831 14.4594 6.51805 11.9926 8.16627C9.52589 9.81449 7.6033 12.1572 6.46799 14.8981C5.33267 17.639 5.03562 20.655 5.6144 23.5647C6.19318 26.4744 7.62179 29.1471 9.71958 31.2449C11.8174 33.3427 14.4901 34.7713 17.3998 35.3501C20.3095 35.9289 23.3255 35.6318 26.0664 34.4965C28.8073 33.3612 31.15 31.4386 32.7982 28.9719C34.4464 26.5051 35.3262 23.605 35.3262 20.6383C35.3262 16.6601 33.7458 12.8448 30.9328 10.0317C28.1197 7.21867 24.3044 5.63831 20.3262 5.63831Z",
    fill: "#E58B27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0637 28.1383L19.0762 21.1508V9.38831H21.5762V20.1133L27.8262 26.3758L26.0637 28.1383Z",
    fill: "#E58B27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeOrange);
export default __webpack_public_path__ + "static/media/icon-time-orange.9566151fa2947c4e2240db13fc501d05.svg";
export { ForwardRef as ReactComponent };